import React from 'react';
import { Toaster } from 'react-hot-toast';
import CadastroForm from './components/CadastroForm';
import { GlobalStyle } from './styles/GlobalStyle';
import { ZeplinAppContainer, ZeplinHeader, ZeplinLogo, ZeplinContent } from './styles/ZeplinStyles';


function App() {
  return (
    <>
      <GlobalStyle />
      <ZeplinAppContainer>
        <Toaster 
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
              fontFamily: 'Montserrat, sans-serif',
            },
          }}
        />
        
        <ZeplinHeader aria-label="BHBAND — Cadastro">
          <ZeplinLogo>
            <a href="https://www.bhband.com.br/">
              <img src="/bhband_logo.png?v=2025080420" alt="BHBAND" className="logo-image" />
            </a>
          </ZeplinLogo>
        </ZeplinHeader>

        <ZeplinContent>
          <CadastroForm />
        </ZeplinContent>
      </ZeplinAppContainer>
    </>
  );
}

export default App; 